export const Types = {
  SET: 'messages/SET',
  CLEAR: 'messages/CLEAR',
};

const INITIAL_STATE = { message: null, type: null, liveAfterRedirect: false };

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case Types.SET:
      return { ...state, ...action.payload };

    case Types.CLEAR:
      if (state.liveAfterRedirect) return { ...state, liveAfterRedirect: false };

      return { message: null, type: null, liveAfterRedirect: false };

    default:
      return state;
  }
};

export const Creators = {
  setMessage: (message, type, liveAfterRedirect = false) => ({
    type: Types.SET,
    payload: { message, type, liveAfterRedirect },
  }),
  clearMessages: () => ({ type: Types.CLEAR }),
};



// WEBPACK FOOTER //
// ./src/store/ducks/messages.js